import type { FaireProductEntity } from "../../entity_types/product";

export const p_2q6fdd5t5p: FaireProductEntity = {
  token: "p_2q6fdd5t5p",
  type: "product",
  name: "Mini Crystal Pyramid",
  brandToken: "b_8h5sk43qpz",
  brandName: "Down To Earth",
  imageUrl:
    "https://cdn.faire.com/fastly/6cfe683befa07d54b156bc0ebb8e05f6bb566b35fa936dd6a5d56d00a300361c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/920d8c5c29608a95c0e07a0c33cc4238b3c77f4843f073eb174ab143bb40cddd.jpeg",
    "https://cdn.faire.com/fastly/17ee6b0ad493a5dbbe8efed3a0fac53684a62165fca66434bd9a52f29ace7917.jpeg",
    "https://cdn.faire.com/fastly/987b1791cf8e73553d3be67726f39a7a83e25c1a42c481ced062ecefc0f3eefd.jpeg",
    "https://cdn.faire.com/fastly/dc0f9c2668f6cb115d49ab1ad9c52a491519cb8928563973bdd7f31ee4c39676.jpeg",
    "https://cdn.faire.com/fastly/2fe32dffb63d7c924fd0cd1f61015e146c3bcbb4783e1f57a6e6bd75321e4f43.jpeg",
    "https://cdn.faire.com/fastly/88e5e95720add8b20fe66fbd118d7d3a62401f44a74ff2f693d19f84f74c4547.jpeg",
    "https://cdn.faire.com/fastly/5c120453e17167f88549b674a59fda5aa89836aa63ba9c0109e2b94c1f330c5c.jpeg",
    "https://cdn.faire.com/fastly/de2a08248f553e0ad4902e58db9cf2f270bd784e57fe043273e7cde8109bf524.jpeg",
    "https://cdn.faire.com/fastly/2dabe7803a085c30f17370d82f72c1c09267953000886506067f19e17cf05ea7.jpeg",
    "https://cdn.faire.com/fastly/946b3454872d6926fad004f874e760baf66f2ca4ae4eb083e1eea72b9bc9c0c1.jpeg",
    "https://cdn.faire.com/fastly/983d811a0fbed99f96c0feb0ac03b709f0028c371d4d5a17ccb1e8a7c4c2339c.jpeg",
    "https://cdn.faire.com/fastly/cf6b90f68a624a246cb850a8f9894cb829195253c173df7be1c2dffea5e1fdfb.jpeg",
  ],
  priceDollars: 8,
  description:
    "Bring balance, beauty, and high vibrations into your space with our Mini Crystal Pyramids, each carefully hand carved from genuine stone. Measuring approximately 25mm, these pocket sized pyramids are perfect for energy work, meditation, decor, or crystal grids.\n\nThe pyramid shape has long been associated with amplifying and focusing energy, making it an ideal form for manifesting intentions or harmonizing your surroundings. Whether displayed on your altar, desk, or carried with you throughout the day, these mini pyramids offer a simple yet powerful way to connect with your favorite crystals.\n\n * Approx. size: 25mm (1 inch) \n * Hand carved from natural crystal (variations in color and pattern are normal) \n * Ideal for energy healing, meditation, home decor, or gifting ",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:29.478Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
